import { useState, useCallback, useRef } from 'react';
import { Toast } from 'primereact/toast';
import {
  LoginTemplateList,
  LoginTemplateDialog,
  LoginTemplateHistoryDialog,
} from '@authifi/login-pages';
import type { HtmlTemplate } from '@authifi/login-pages';

export function LoginPagesPage() {
  const toast = useRef<Toast>(null);
  const [showCreateDialog, setShowCreateDialog] = useState(false);
  const [editTemplateId, setEditTemplateId] = useState<number | undefined>(undefined);
  const [historyTemplateId, setHistoryTemplateId] = useState<number | undefined>(undefined);
  const [historyTemplateName, setHistoryTemplateName] = useState<string | undefined>(undefined);

  const handleTemplateSelect = useCallback((template: HtmlTemplate) => {
    setEditTemplateId(template.id);
  }, []);

  const handleSaved = useCallback((template: HtmlTemplate) => {
    toast.current?.show({
      severity: 'success',
      summary: 'Template Saved',
      detail: `"${template.name}" has been saved.`,
      life: 3000,
    });
  }, []);

  const handleHistoryClick = useCallback(
    (templateId: number) => {
      const name = editTemplateId === templateId ? undefined : undefined;
      setHistoryTemplateId(templateId);
      setHistoryTemplateName(name);
    },
    [editTemplateId],
  );

  const handleDialogHide = useCallback(() => {
    setShowCreateDialog(false);
    setEditTemplateId(undefined);
  }, []);

  return (
    <div>
      <Toast ref={toast} />
      <h2 className="text-2xl font-semibold text-[var(--clique-fg)] mb-2">Login Pages</h2>
      <p className="text-[var(--clique-fg-muted)] mb-6">
        Manage and customize login page templates.
      </p>

      <LoginTemplateList
        onTemplateSelect={handleTemplateSelect}
        onCreateTemplate={() => setShowCreateDialog(true)}
      />

      <LoginTemplateDialog
        visible={showCreateDialog || editTemplateId != null}
        onHide={handleDialogHide}
        templateId={editTemplateId}
        onSaved={handleSaved}
        onHistoryClick={handleHistoryClick}
      />

      {historyTemplateId != null && (
        <LoginTemplateHistoryDialog
          visible
          onHide={() => {
            setHistoryTemplateId(undefined);
            setHistoryTemplateName(undefined);
          }}
          templateId={historyTemplateId}
          templateName={historyTemplateName}
        />
      )}
    </div>
  );
}
